import { Offcanvas } from "react-bootstrap";
import styled from "styled-components";


interface IDisconnectModalStyledProps {
    show: string;
}

export const DisconnectModalStyled = styled.div<IDisconnectModalStyledProps>`
    height: ${({ show }) => show ? '32px' : '0' }; 
    transition: all .3s ease-in-out;
`

export const DisconnectModalOffcanvasStyled = styled(Offcanvas)`
    &.offcanvas-bottom {
        height: 32px;
        font-size: 12px;
        line-height: 16px;
        color: ${({ error }) => error ? 'var(--color-red)' : 'var(--color-white-95)'};
        background-color: ${({ error }) => error ? '#492A3A' : 'var(--color-neutral-20)'};
        border-radius: 0;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        overflow: hidden;
    }
`;